var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { createAsyncThunk } from '@reduxjs/toolkit';
import { classToPlain } from 'class-transformer';
import { AppError } from '../../error';
import { NotificationDownloadService } from '../services';
import { DownloadNotificationEventEmitter } from '../types';
import { DownloadService } from '../../download';
const delay = (time) => new Promise((resolve) => {
    setTimeout(() => resolve(null), time);
});
export const setDownloadWaiting = createAsyncThunk('core/downloadNotification/setDownloadWaiting', (args, { extra: { inject } }) => {
    var _a;
    const eventEmitter = inject(DownloadNotificationEventEmitter);
    eventEmitter.onShow({
        id: args.id,
        status: 'waiting',
        text: (_a = args.text) === null || _a === void 0 ? void 0 : _a.loading,
    });
    return args;
});
export const setDownloadComplete = createAsyncThunk('core/downloadNotification/setDownloadComplete', (args_1, _a) => __awaiter(void 0, [args_1, _a], void 0, function* (args, { getState, extra: { inject } }) {
    var _b;
    const eventEmitter = inject(DownloadNotificationEventEmitter);
    const downloads = getState().downloadNotification.downloads;
    const download = downloads.find(({ id }) => id === args.id);
    eventEmitter.onShow({
        id: args.id,
        status: 'complete',
        text: (_b = download === null || download === void 0 ? void 0 : download.text) === null || _b === void 0 ? void 0 : _b.complete,
    });
    return args;
}));
export const setDownloadFailed = createAsyncThunk('core/downloadNotification/setDownloadFailed', (args_1, _a) => __awaiter(void 0, [args_1, _a], void 0, function* (args, { getState, extra: { inject } }) {
    var _b;
    const eventEmitter = inject(DownloadNotificationEventEmitter);
    const downloads = getState().downloadNotification.downloads;
    const download = downloads.find(({ id }) => id === args.id);
    eventEmitter.onShow({
        id: args.id,
        status: 'failed',
        text: (_b = download === null || download === void 0 ? void 0 : download.text) === null || _b === void 0 ? void 0 : _b.failed,
    });
    return args;
}));
export const cancelDownloads = createAsyncThunk('core/downloadNotification/cancelDownloads', (_1, _a) => __awaiter(void 0, [_1, _a], void 0, function* (_, { extra: { inject } }) {
    const eventEmitter = inject(DownloadNotificationEventEmitter);
    eventEmitter.onCancel();
    return;
}));
export const pollDownloadStatus = createAsyncThunk('core/downloadNotification/pollDownloadStatus', (batchDownloadDto_1, _a) => __awaiter(void 0, [batchDownloadDto_1, _a], void 0, function* (batchDownloadDto, { getState, rejectWithValue, dispatch, extra: { inject } }) {
    try {
        const second = 1000;
        const service = inject(NotificationDownloadService);
        yield delay(second);
        let downloadEntity = yield service.getStatus(batchDownloadDto);
        while (downloadEntity.download.status === 'in_progress') {
            const state = getState().downloadNotification.downloads;
            const fiveSeconds = 5000;
            if (!state.length) {
                break;
            }
            yield delay(fiveSeconds);
            downloadEntity = yield service.getStatus(batchDownloadDto);
        }
        if (downloadEntity.download.status === 'error' ||
            downloadEntity.download.status === 'expired') {
            dispatch(setDownloadFailed({
                id: batchDownloadDto.download_id,
                errorMessage: downloadEntity.download.error_message &&
                    `Ошибка: ${downloadEntity.download.error_message}`,
            }));
            throw new AppError('server', {
                code: 500,
                message: `Status ${downloadEntity.download.status}`,
            });
        }
        if (downloadEntity.download.status === 'done' &&
            getState().downloadNotification.downloads.length) {
            dispatch(setDownloadComplete({ id: batchDownloadDto.download_id }));
            service
                .getArchive(batchDownloadDto)
                .then((_a) => __awaiter(void 0, [_a], void 0, function* ({ file, filename }) {
                yield inject(DownloadService).doDownload(file, filename || 'documents.zip');
            }));
        }
        return downloadEntity;
    }
    catch (err) {
        return rejectWithValue(classToPlain(err));
    }
}));
export const downloadNotificationReducers = (builder) => {
    builder.addCase(setDownloadWaiting.fulfilled, (state, action) => {
        const { id, count, text } = action.payload;
        state.downloads = [
            ...state.downloads,
            { id, status: 'waiting', counter: count, text },
        ];
    });
    builder.addCase(setDownloadComplete.fulfilled, (state, action) => {
        state.downloads = state.downloads.map((item) => {
            if (item.id === action.payload.id) {
                return Object.assign(Object.assign({}, item), { status: 'complete' });
            }
            return item;
        });
    });
    builder.addCase(setDownloadFailed.fulfilled, (state, action) => {
        state.downloads = state.downloads.map((item) => {
            if (item.id === action.payload.id) {
                return Object.assign(Object.assign(Object.assign({}, item), (item.text && {
                    text: Object.assign(Object.assign({}, item.text), { failed: action.meta.arg.errorMessage || item.text.failed }),
                })), { status: 'failed' });
            }
            return item;
        });
    });
    builder.addCase(cancelDownloads.fulfilled, (state) => {
        state.downloads = [];
    });
};
